import { AuthService } from './../../../services/auth.service';
import { SearchService } from 'src/app/services/search.service';
import { BookingService } from 'src/app/services/booking.service';
import { Component, Renderer2, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AvailabilityAdvanceFilterModel } from 'src/app/models/AvailabilityAdvanceFilterModel'
import { SelectListItems } from 'src/app/models/AdvanceSearchDataModel';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { NotificationsService } from 'angular2-notifications';
import { async, ComponentFixture, TestBed } from '@angular/core/testing';

import { MatSelect } from '@angular/material/select';
import { AfterViewInit, ViewChild } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';



@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit, OnDestroy, AfterViewInit {

  faTimesCircle = faTimesCircle;
  vehicleTypes;
  vehicleClasses;
  fuelTypes;
  AdditionalServices;
  gearboxs;
  storages;
  passengers;
  freePolicies;
  currency;
  searchModel;
  form: FormGroup;
  makes: SelectListItems[];
  models: SelectListItems[];
  submited = false;
  searchType: VehicleSearchTypeEnum;
  features: SelectListItems[];
  showValidPrice = false;
  noEntriesFoundLabel;

  /** control for the MatSelect filter keyword multi-selection */
  vehicleTypeFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  filteredvehicleTypeMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);


  fuelTypesFilterCtrl: FormControl = new FormControl();
  filteredFuelTypesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  vehicleClassesFilterCtrl: FormControl = new FormControl();
  filteredVehicleClassesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);


  additionalServicesFilterCtrl: FormControl = new FormControl();
  filteredAdditionalServicesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);



  gearboxsFilterCtrl: FormControl = new FormControl();
  filteredGearboxsMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);


  storagesFilterCtrl: FormControl = new FormControl();
  filteredStoragesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  passengersFilterCtrl: FormControl = new FormControl();
  filteredPassengersMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  freePoliciesFilterCtrl: FormControl = new FormControl();
  filteredFreePoliciesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);


  makesFilterCtrl: FormControl = new FormControl();
  filteredMakesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  modelsFilterCtrl: FormControl = new FormControl();
  filteredModelsMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  featuresFilterCtrl: FormControl = new FormControl();
  filteredFeaturesMulti: ReplaySubject<SelectListItems[]> = new ReplaySubject<SelectListItems[]>(1);

  @ViewChild('vehcileTypeSelect', { static: true }) vehcileTypeSelect: MatSelect;
  matSelectSearchLabel: string;
  advanceForm: any;
  customerID: any;

  constructor(
    private authService:AuthService,
    private ren: Renderer2,
    private dialogRef: MatDialogRef<FilterComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private bookingService: BookingService,
    private searchService: SearchService,
    private notificationService: NotificationsService,
  ) {

    //this.vehicleTypes = bookingService.getVehicleType();
    //this.vehicleClasses = bookingService.getVehicleClasses();
    //this.fuelTypes = bookingService.getFuelTypes();
    // this.AdditionalServices = bookingService.getAdditionalServices();
    // this.gearboxs = bookingService.getGearboxs();
    // this.storages = bookingService.getStorages();
    // this.passengers = bookingService.getPassengers();
    // this.freePolicies = bookingService.getFreePolicies();
    this.currency = searchService.getCurrency();

  }


  ngOnInit() {

    this.authService.loggedInCustomer.subscribe(res =>{
      if(res!=null){
        this.customerID=res.customerID;
      }

    })
    if (this.data != null) {

      this.searchType = this.data.searchType;
      if (this.data.advanceForm != null) {
        this.advanceForm = this.data.advanceForm;
      }
    }
    this.searchService.searchModel.subscribe(res => {
      this.searchModel = res;

    });
    this.searchService.getAdvanceSearchData().subscribe(res => {
      if (res != null) {


        this.vehicleTypes = res.vehicleTypes;
        this.vehicleClasses = res.vehicleClasses;
        this.fuelTypes = res.fuelTypes;
        this.AdditionalServices = res.additionalServiceModels;
        this.gearboxs = res.gearbox;
        this.storages = res.storage;
        this.passengers = res.passenger;
        this.freePolicies = res.policyDefinitions;
        this.makes = res.makeIDs;
        this.models = res.modelIDs;
        this.features = res.feauture;

        this.filteredvehicleTypeMulti.next(this.vehicleTypes.slice());
        // listen for search field value changes
        this.vehicleTypeFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredvehicleTypeMulti, this.vehicleTypes, this.vehicleTypeFilterCtrl);
          });

        this.filteredVehicleClassesMulti.next(this.vehicleClasses.slice());
        // listen for search field value changes
        this.vehicleClassesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredVehicleClassesMulti, this.vehicleClasses, this.vehicleClassesFilterCtrl);
          });

        this.filteredFuelTypesMulti.next(this.fuelTypes.slice());
        // listen for search field value changes
        this.fuelTypesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredFuelTypesMulti, this.fuelTypes, this.fuelTypesFilterCtrl);
          });

        this.filteredAdditionalServicesMulti.next(this.AdditionalServices.slice());
        // listen for search field value changes
        this.additionalServicesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredAdditionalServicesMulti, this.AdditionalServices, this.additionalServicesFilterCtrl);
          });

        this.filteredGearboxsMulti.next(this.gearboxs.slice());
        // listen for search field value changes
        this.gearboxsFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredGearboxsMulti, this.gearboxs, this.gearboxsFilterCtrl);
          });
        this.filteredStoragesMulti.next(this.storages.slice());
        // listen for search field value changes
        this.storagesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredStoragesMulti, this.storages, this.storagesFilterCtrl);
          });
        this.filteredPassengersMulti.next(this.passengers.slice());
        // listen for search field value changes
        this.passengersFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredPassengersMulti, this.passengers, this.passengersFilterCtrl);
          });
        this.filteredFreePoliciesMulti.next(this.freePolicies.slice());
        // listen for search field value changes
        this.freePoliciesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredFreePoliciesMulti, this.freePolicies, this.freePoliciesFilterCtrl);
          });
        this.filteredMakesMulti.next(this.makes.slice());
        // listen for search field value changes
        this.makesFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredMakesMulti, this.makes, this.makesFilterCtrl);
          });
        this.filteredModelsMulti.next(this.models.slice());
        // listen for search field value changes
        this.modelsFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredModelsMulti, this.models, this.modelsFilterCtrl);
          });

        this.filteredFeaturesMulti.next(this.features.slice());
        // listen for search field value changes
        this.featuresFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMatSelectDataMulti(this.filteredFeaturesMulti, this.features, this.featuresFilterCtrl);
          });
      }
    })

    if (this.advanceForm == null) {
      this.initForm();
      if (this.searchType == VehicleSearchTypeEnum.MakeModelYearSearch || this.searchType == VehicleSearchTypeEnum.vehicleSearch) {
        this.form.addControl('make', new FormControl());
        this.form.addControl('model', new FormControl());
        this.form.addControl('year', new FormControl(null))
      }
      if (this.searchType == VehicleSearchTypeEnum.vehicleSearch) {
        this.form.addControl('isFullRequired', new FormControl());
        this.form.addControl('odometer', new FormControl(null))
        this.form.addControl('addOn', new FormControl(null))
      }
    }
    else {
      this.form = this.advanceForm;
    }



    this.noEntriesFoundLabel = "No Data found";
    this.matSelectSearchLabel = '';





    //Eman Add it for search makes
    // load the initial makes list
    this.filteredMakes.next(this.makesFilter.slice());
    // listen for search field value changes
    this.makeFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterMakes();
      });




  }



  get VehicleSearchTypeEnum() {
    return VehicleSearchTypeEnum;
  }

  initForm() {
    this.form = new FormGroup({
      vehicleType: new FormControl('',),
      vehicleClass: new FormControl('',),
      fuelType: new FormControl('',),
      // PriceFrom: new FormControl(),
      // PriceTo: new FormControl(),
      AdditionalService: new FormControl('',),
      gearbox: new FormControl('',),
      storage: new FormControl('',),
      passenger: new FormControl('',),
      yes: new FormControl('',),
      no: new FormControl('',),
      freePolicies: new FormControl('',),
      promotionCampaigns: new FormControl(),

    });


  }

  close(): void {
    this.dialogRef.close();
  }
  cancel() {
    this.dialogRef.close({ cancel: true });
  }


  onSubmit() {
    //alert(JSON.stringify(this.form.value));
    //Eman Add this to check price
    this.submited = true;

    // if (this.form.controls.PriceFrom.value > this.form.controls.PriceTo.value && this.form.controls.PriceTo.value!=null) {
    //   this.showValidPrice = true;
    //   this.submited = false;
    // }

    if (this.submited == true) {

      this.searchService.advanceSearchFilterForm = this.form;
      let advanceSearch: AvailabilityAdvanceFilterModel = {
        VehicleClass: this.convertToListOfNumber(this.form.controls.vehicleClass.value),
        VehicleType: this.convertToListOfNumber(this.form.controls.vehicleType.value),
        FuelType: this.convertToListOfNumber(this.form.controls.fuelType.value),
        Storage: this.convertStringToNumber(this.form.controls.storage.value),
        Passengers: this.convertStringToNumber(this.form.controls.passenger.value),
        FreePolicies: this.convertToListOfNumber(this.form.controls.freePolicies.value),
        AdditionalServicesAndCharges: this.convertToListOfNumber(this.form.controls.AdditionalService.value),

        // PriceFrom: this.form.controls.PriceFrom.value,
        // PriceTo: this.form.controls.PriceTo.value,
        HavePromotionCampaigns: this.form.controls.promotionCampaigns.value,
      }


      if (this.searchType == VehicleSearchTypeEnum.MakeModelYearSearch || this.searchType == VehicleSearchTypeEnum.vehicleSearch) {
        advanceSearch.MakeID = this.convertStringToNumber(this.form.controls.make.value);
        advanceSearch.ModelID = this.convertStringToNumber(this.form.controls.model.value);
        advanceSearch.Year = this.convertStringToNumber(this.form.controls.year.value);
      }
      if (this.searchType == VehicleSearchTypeEnum.vehicleSearch) {
        advanceSearch.odometer = this.form.controls.odometer.value;
        advanceSearch.isFullRequired = this.form.controls.isFullRequired.value;
        advanceSearch.Features = this.convertToListOfNumber(this.form.controls.addOn.value);
      }

      advanceSearch.GearBox = this.convertStringToNumber(this.form.controls.gearbox.value);


      this.searchModel["AvailabilityAdvanceFilter"] = advanceSearch;
      if(this.customerID!=null){
        this.searchModel["CustomerID"] = this.customerID;
      }


        this.searchService.VehicleReservationAdvanceSearch(this.searchModel).subscribe(res => {
          if (res != null) {

          }

          this.searchService.updateVehicleReservationSearchAgency(res);

          this.dialogRef.close({ form: this.form });
        }, err => {
          this.notificationService.warn("SomethingWentWrong", null, {
            timeOut: 3000,
            showProgressBar: false,
            pauseOnHover: true,
            clickToClose: true
          });
        })



    }

  }

  convertStringToNumber(stringVal) {
    if (stringVal != null && stringVal != "") {
      return parseInt(stringVal);
    }
    else {
      return null;
    }

  }
  convertToListOfNumber(list: string[]) {
    if (list != null && list.length > 0) {
      return list.map(function (item) {
        return parseInt(item, 10);
      });
    }
    return null;

  }

  makeIDChanged(value) {
    this.searchService.getModelsByMakeID(value).subscribe(res => {
      this.models = res;
    })
  }




  //Eman Add it for search makes
  protected makesFilter: Make[] = MAKES;
  public makeCtrl: FormControl = new FormControl();
  public makeFilterCtrl: FormControl = new FormControl();
  public filteredMakes: ReplaySubject<Make[]> = new ReplaySubject<Make[]>(1);
  @ViewChild('singleSelect') singleSelect: MatSelect;
  protected _onDestroy = new Subject<void>();

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected setInitialValue() {
    this.filteredMakes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: Make, b: Make) => a && b && a.text === b.text;
      });


    this.filteredvehicleTypeMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        //this.vehcileTypeSelect.compareWith = (a: SelectListItems, b: SelectListItems) => a && b && a.value === b.value;
      });

    this.filteredVehicleClassesMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
      });


  }

  protected filterMakes() {
    if (!this.makesFilter) {
      return;
    }
    // get the search keyword
    let search = this.makeFilterCtrl.value;
    if (!search) {
      this.filteredMakes.next(this.makesFilter.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredMakes.next(
      this.makesFilter.filter(make => make.text.toLowerCase().indexOf(search) > -1)
    );
  }

  filterMatSelectDataMulti(replySubjectObject, list, ctrl: FormControl) {
    if (!list) {
      return;
    }
    // get the search keyword
    let search = ctrl.value;
    if (!search) {
      replySubjectObject.next(list.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the vehicleTypes
    replySubjectObject.next(
      list.filter(item => item.text.toLowerCase().indexOf(search) > -1)
    );
  }

  currentCheckedValue = null;

  checkState(el) {
    setTimeout(() => {
      if (this.currentCheckedValue || this.currentCheckedValue === el.value) {
        //el.checked = false;
        this.form.controls['promotionCampaigns'].reset();

        this.ren.removeClass(el['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(el['_elementRef'].nativeElement, 'cdk-program-focused');
        this.currentCheckedValue = null;
      } else {
        this.currentCheckedValue = el.value
      }
    })
  }


}

export interface Make {
  text: string;
}

export const MAKES: Make[] = [
  { text: 'Switzerland' },
  { text: 'Switzerland' },
  { text: 'France' },
  { text: 'Australia' },
  { text: 'France' },
  { text: 'Italy' },
  { text: 'Kolombia' },
  { text: 'Germany' },
  { text: 'iraq' },
  { text: 'Jordan' },
];
